import '../src/base';
import '~/app/assets/javascripts/application/sitewide';
import $ from 'jquery';
import LocationSelector from 'components/location_selector';
import UserService from 'services/user_service';

function navigationBehaviour() {
  const $navigationToggleButton = $('.js-nav-toggle-button');
  const $mobileNavigation = $('.js-navigation-mobile');
  const $pageBody = $('body');
  const $desktopNavigation = $('.js-navigation-desktop');
  const desktopNavigationOffsetTop = $desktopNavigation.offset().top;
  const desktopNavigationFixedClass = 'navigation-desktop--fixed';
  const $navigationLinkDesktop = $('.js-navigation-link-desktop');
  const $navigationLink = $('.js-navigation-link, .js-navigation-link-desktop');
  const navigationLinkActiveClass = 'navigation-content__link--active';

  function setNavigationPosition() {
    if ($(window).scrollTop() >= desktopNavigationOffsetTop) {
      $desktopNavigation.addClass(desktopNavigationFixedClass);
      $('.js-benefits-section').addClass('benefits-section--fixed-navigation');
    } else {
      $desktopNavigation.removeClass(desktopNavigationFixedClass);
      $('.js-benefits-section').removeClass('benefits-section--fixed-navigation');
    }
  }

  function setNavigationActiveLink() {
    const scrollRef = $(window).scrollTop() + 200;

    $navigationLinkDesktop.each((_index, link) => {
      const $currentLink = $(link);
      const relatedSection = $($currentLink.attr('href'));

      if (relatedSection.position().top <= scrollRef &&
          relatedSection.position().top + (relatedSection.height() + 70) >= scrollRef) {
        $navigationLinkDesktop.removeClass(navigationLinkActiveClass);
        $currentLink.addClass(navigationLinkActiveClass).focus();
      } else {
        $currentLink.removeClass(navigationLinkActiveClass);
      }
    });

    if ($(window).scrollTop() + $(window).height() === $(document).height()) {
      $navigationLinkDesktop.removeClass(navigationLinkActiveClass);
      $('.js-contact-navigation-link').addClass(navigationLinkActiveClass).focus();
    }
  }

  function updateNavigationBar() {
    setNavigationPosition();
    setNavigationActiveLink();
  }

  function scrollToSection(sectionName) {
    $('html, body').animate({
      scrollTop: $(sectionName).offset().top - 80,
    }, 500);
  }

  $navigationToggleButton.on('click', () => {
    $mobileNavigation.toggleClass('navigation-mobile--open');
    $pageBody.toggleClass('body-with-open-navigation');
  });

  updateNavigationBar();

  $(window).scroll(() => updateNavigationBar());

  $navigationLink.click((event) => {
    event.preventDefault();
    $mobileNavigation.removeClass('navigation-mobile--open');
    $pageBody.removeClass('body-with-open-navigation');
    const sectionName = $.attr(event.currentTarget, 'href');
    scrollToSection(sectionName);
  });

  const locationSelector = new LocationSelector('.js-location');

  locationSelector.on('change', (location) => {
    UserService.updateLocation(location).catch((error) => {
      Rollbar.error('HomeUpdateUserLocation', error);
    });
  });

  window.QB.instances = window.QB.instances || {};
  window.QB.instances.locationSelector = locationSelector;
}

function faqBehaviour() {
  const $accordionItems = $('.js-faq-item');

  $accordionItems.each((_index, element) => {
    const $currentAccordionItem = $(element);

    $currentAccordionItem.click(() => {
      $currentAccordionItem.toggleClass('z-accordion__item--is-open');
    });
  });
}

function setFixedBar() {
  const $bodyCta = $('.js-navigation-link');
  const $footer = $('.js-footer');
  const $fixedBar = $('.js-fixed-bar');
  let showFixedBar = false;
  $fixedBar.css('bottom', `${-($fixedBar.outerHeight() + 10)}px`);

  window.addEventListener('scroll', () => {
    if (window.pageYOffset >= $bodyCta.offset().top + $bodyCta.height()) {
      if (!showFixedBar) {
        $fixedBar.css('bottom', 0);
        showFixedBar = true;
      }

      if ($fixedBar.offset().top >= $footer.offset().top) {
        $fixedBar.css('position', 'relative');
      } else if ($(window).scrollTop() + $(window).height() <= $fixedBar.offset().top + ($fixedBar.outerHeight() - 5)) {
        $fixedBar.css('position', 'fixed');
      }
    } else if (showFixedBar) {
      $fixedBar.css('bottom', `${-($fixedBar.outerHeight() + 10)}px`);
      showFixedBar = false;
    }
  });
}

$(() => {
  navigationBehaviour();
  faqBehaviour();
  setFixedBar();
});
